import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import ws from './ws';
import errors from './errors';
import statusCodes from './statusCodes';
import { objectHasOwnProperty, getProtocolFromEndpoint } from './utils';
import config from './config';

var _checkSignedInState = function _checkSignedInState() {
  if (ws.reconnecting) throw new errors.Reconnecting();
  if (!ws.keys.init && ws.changePassword) throw new errors.UserMustChangePassword();
  if (!ws.keys.init) throw new errors.UserNotSignedIn();
};

var _parseGenericErrors = function _parseGenericErrors(e) {
  if (e.response) {
    if (e.response.status === statusCodes['Internal Server Error']) {
      throw new errors.InternalServerError();
    } else if (e.response.status === statusCodes['Gateway Timeout']) {
      throw new errors.Timeout();
    }
  } else if (e.message && e.message.indexOf('timeout') !== -1) {
    throw new errors.Timeout();
  }
};

var _validatePurchaseOrUpdate = function _validatePurchaseOrUpdate(params) {
  _checkSignedInState();

  var stripeData = ws.userData.stripeData;
  if (!stripeData.stripeAccountId) throw new errors.StripeAccountNotConnected();
  if (stripeData.paymentsMode === 'disabled') throw new errors.PaymentsDisabled();
  if (!objectHasOwnProperty(window, 'Stripe')) throw new errors.StripeJsLibraryMissing();
  if (typeof params !== 'object') throw new errors.ParamsMustBeObject();
  if (!objectHasOwnProperty(params, 'successUrl')) throw new errors.SuccessUrlMissing();
  if (typeof params.successUrl !== 'string') throw new errors.SuccessUrlMustBeString();
  var successUrlProtocol = getProtocolFromEndpoint(params.successUrl);

  if (successUrlProtocol !== 'http' && successUrlProtocol !== 'https') {
    var invalidProtocol = true;
    throw new errors.SuccessUrlInvalid(invalidProtocol);
  }

  if (!objectHasOwnProperty(params, 'cancelUrl')) throw new errors.CancelUrlMissing();
  if (typeof params.cancelUrl !== 'string') throw new errors.CancelUrlMustBeString();
  var cancelUrlProtocol = getProtocolFromEndpoint(params.cancelUrl);

  if (cancelUrlProtocol !== 'http' && cancelUrlProtocol !== 'https') {
    var _invalidProtocol = true;
    throw new errors.CancelUrlInvalid(_invalidProtocol);
  }
};

var purchaseSubscription = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
    var stripeData, action, sessionIdResponse, stripeSessionId, stripePk, result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            stripeData = ws.userData.stripeData;

            if (!(!stripeData.cancelSubscriptionAt && stripeData.subscriptionStatus && stripeData.subscriptionStatus !== 'canceled')) {
              _context.next = 4;
              break;
            }

            throw new errors.SubscriptionPlanAlreadyPurchased();

          case 4:
            _validatePurchaseOrUpdate(params);

            _context.prev = 5;
            action = 'PurchaseSubscription';
            _context.next = 9;
            return ws.request(action, params);

          case 9:
            sessionIdResponse = _context.sent;
            stripeSessionId = sessionIdResponse.data;
            stripePk = config.getStripePublishableKey(stripeData.paymentsMode === 'prod');
            _context.next = 14;
            return window.Stripe(stripePk, {
              stripeAccount: stripeData.stripeAccountId
            }).redirectToCheckout({
              sessionId: stripeSessionId
            });

          case 14:
            result = _context.sent;

            if (!result.error) {
              _context.next = 17;
              break;
            }

            throw result.error;

          case 17:
            _context.next = 34;
            break;

          case 19:
            _context.prev = 19;
            _context.t0 = _context["catch"](5);

            _parseGenericErrors(_context.t0);

            if (!_context.t0.response) {
              _context.next = 33;
              break;
            }

            _context.t1 = _context.t0.response.data;
            _context.next = _context.t1 === 'PriceIdOrPlanIdAllowed' ? 26 : _context.t1 === 'PriceIdOrPlanIdMissing' ? 27 : _context.t1 === 'SubscriptionPlanAlreadyPurchased' ? 28 : _context.t1 === 'SuccessUrlInvalid' ? 29 : _context.t1 === 'CancelUrlInvalid' ? 30 : 31;
            break;

          case 26:
            throw new errors.PriceIdOrPlanIdAllowed();

          case 27:
            throw new errors.PriceIdOrPlanIdMissing();

          case 28:
            throw new errors.SubscriptionPlanAlreadyPurchased();

          case 29:
            throw new errors.SuccessUrlInvalid();

          case 30:
            throw new errors.CancelUrlInvalid();

          case 31:
            if (!(_context.t0.response.data && _context.t0.response.data.name === 'StripeError')) {
              _context.next = 33;
              break;
            }

            throw new errors.StripeError(_context.t0.response.data);

          case 33:
            throw _context.t0;

          case 34:
            _context.next = 43;
            break;

          case 36:
            _context.prev = 36;
            _context.t2 = _context["catch"](0);
            _context.t3 = _context.t2.name;
            _context.next = _context.t3 === 'ParamsMustBeObject' ? 41 : _context.t3 === 'SuccessUrlMissing' ? 41 : _context.t3 === 'SuccessUrlMustBeString' ? 41 : _context.t3 === 'SuccessUrlInvalid' ? 41 : _context.t3 === 'CancelUrlMissing' ? 41 : _context.t3 === 'CancelUrlMustBeString' ? 41 : _context.t3 === 'CancelUrlInvalid' ? 41 : _context.t3 === 'StripeError' ? 41 : _context.t3 === 'StripeJsLibraryMissing' ? 41 : _context.t3 === 'PriceIdOrPlanIdAllowed' ? 41 : _context.t3 === 'PriceIdOrPlanIdMissing' ? 41 : _context.t3 === 'SubscriptionPlanAlreadyPurchased' ? 41 : _context.t3 === 'StripeAccountNotConnected' ? 41 : _context.t3 === 'PaymentsDisabled' ? 41 : _context.t3 === 'UserMustChangePassword' ? 41 : _context.t3 === 'UserNotSignedIn' ? 41 : _context.t3 === 'TooManyRequests' ? 41 : _context.t3 === 'ServiceUnavailable' ? 41 : 42;
            break;

          case 41:
            throw _context.t2;

          case 42:
            throw new errors.UnknownServiceUnavailable(_context.t2);

          case 43:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 36], [5, 19]]);
  }));

  return function purchaseSubscription(_x) {
    return _ref.apply(this, arguments);
  };
}();

var _validateModifySubscriptionConditions = function _validateModifySubscriptionConditions() {
  _checkSignedInState();

  var stripeData = ws.userData.stripeData;
  if (!stripeData.stripeAccountId) throw new errors.StripeAccountNotConnected();
  if (stripeData.paymentsMode === 'disabled') throw new errors.PaymentsDisabled();
  if (stripeData.subscriptionStatus === 'canceled') throw new errors.SubscriptionAlreadyCanceled();
};

var cancelSubscription = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var action, cancelResponse, cancelSubscriptionAt;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;

            _validateModifySubscriptionConditions();

            _context2.prev = 2;
            action = 'CancelSubscription';
            _context2.next = 6;
            return ws.request(action);

          case 6:
            cancelResponse = _context2.sent;
            cancelSubscriptionAt = cancelResponse.data;
            ws.userData.stripeData.cancelSubscriptionAt = cancelSubscriptionAt;
            return _context2.abrupt("return", {
              cancelSubscriptionAt: cancelSubscriptionAt
            });

          case 12:
            _context2.prev = 12;
            _context2.t0 = _context2["catch"](2);

            _parseGenericErrors(_context2.t0);

            if (!(_context2.t0.response && _context2.t0.response.data === 'SubscriptionNotFound')) {
              _context2.next = 17;
              break;
            }

            throw new errors.SubscriptionNotFound();

          case 17:
            throw _context2.t0;

          case 18:
            _context2.next = 27;
            break;

          case 20:
            _context2.prev = 20;
            _context2.t1 = _context2["catch"](0);
            _context2.t2 = _context2.t1.name;
            _context2.next = _context2.t2 === 'SubscriptionNotFound' ? 25 : _context2.t2 === 'StripeAccountNotConnected' ? 25 : _context2.t2 === 'PaymentsDisabled' ? 25 : _context2.t2 === 'SubscriptionAlreadyCanceled' ? 25 : _context2.t2 === 'UserMustChangePassword' ? 25 : _context2.t2 === 'UserNotSignedIn' ? 25 : _context2.t2 === 'TooManyRequests' ? 25 : _context2.t2 === 'ServiceUnavailable' ? 25 : 26;
            break;

          case 25:
            throw _context2.t1;

          case 26:
            throw new errors.UnknownServiceUnavailable(_context2.t1);

          case 27:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 20], [2, 12]]);
  }));

  return function cancelSubscription() {
    return _ref2.apply(this, arguments);
  };
}();

var resumeSubscription = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var action;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;

            _validateModifySubscriptionConditions();

            _context3.prev = 2;
            action = 'ResumeSubscription';
            _context3.next = 6;
            return ws.request(action);

          case 6:
            delete ws.userData.stripeData.cancelSubscriptionAt;
            _context3.next = 15;
            break;

          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](2);

            _parseGenericErrors(_context3.t0);

            if (!(_context3.t0.response && _context3.t0.response.data === 'SubscriptionNotFound')) {
              _context3.next = 14;
              break;
            }

            throw new errors.SubscriptionNotFound();

          case 14:
            throw _context3.t0;

          case 15:
            _context3.next = 24;
            break;

          case 17:
            _context3.prev = 17;
            _context3.t1 = _context3["catch"](0);
            _context3.t2 = _context3.t1.name;
            _context3.next = _context3.t2 === 'SubscriptionNotFound' ? 22 : _context3.t2 === 'StripeAccountNotConnected' ? 22 : _context3.t2 === 'PaymentsDisabled' ? 22 : _context3.t2 === 'SubscriptionAlreadyCanceled' ? 22 : _context3.t2 === 'UserMustChangePassword' ? 22 : _context3.t2 === 'UserNotSignedIn' ? 22 : _context3.t2 === 'TooManyRequests' ? 22 : _context3.t2 === 'ServiceUnavailable' ? 22 : 23;
            break;

          case 22:
            throw _context3.t1;

          case 23:
            throw new errors.UnknownServiceUnavailable(_context3.t1);

          case 24:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 17], [2, 9]]);
  }));

  return function resumeSubscription() {
    return _ref3.apply(this, arguments);
  };
}();

var updatePaymentMethod = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(params) {
    var stripeData, action, sessionIdResponse, stripeSessionId, stripePk, result;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;

            _validatePurchaseOrUpdate(params);

            stripeData = ws.userData.stripeData;

            if (stripeData.subscriptionStatus) {
              _context4.next = 5;
              break;
            }

            throw new errors.SubscriptionNotPurchased();

          case 5:
            _context4.prev = 5;
            action = 'UpdatePaymentMethod';
            _context4.next = 9;
            return ws.request(action, params);

          case 9:
            sessionIdResponse = _context4.sent;
            stripeSessionId = sessionIdResponse.data;
            stripePk = config.getStripePublishableKey(stripeData.paymentsMode === 'prod');
            _context4.next = 14;
            return window.Stripe(stripePk, {
              stripeAccount: stripeData.stripeAccountId
            }).redirectToCheckout({
              sessionId: stripeSessionId
            });

          case 14:
            result = _context4.sent;

            if (!result.error) {
              _context4.next = 17;
              break;
            }

            throw result.error;

          case 17:
            _context4.next = 30;
            break;

          case 19:
            _context4.prev = 19;
            _context4.t0 = _context4["catch"](5);

            _parseGenericErrors(_context4.t0);

            if (!_context4.t0.response) {
              _context4.next = 29;
              break;
            }

            if (!(_context4.t0.response.data === 'SuccessUrlInvalid')) {
              _context4.next = 27;
              break;
            }

            throw new errors.SuccessUrlInvalid();

          case 27:
            if (!(_context4.t0.response.data === 'CancelUrlInvalid')) {
              _context4.next = 29;
              break;
            }

            throw new errors.CancelUrlInvalid();

          case 29:
            throw _context4.t0;

          case 30:
            _context4.next = 39;
            break;

          case 32:
            _context4.prev = 32;
            _context4.t1 = _context4["catch"](0);
            _context4.t2 = _context4.t1.name;
            _context4.next = _context4.t2 === 'ParamsMustBeObject' ? 37 : _context4.t2 === 'SuccessUrlMissing' ? 37 : _context4.t2 === 'SuccessUrlMustBeString' ? 37 : _context4.t2 === 'SuccessUrlInvalid' ? 37 : _context4.t2 === 'CancelUrlMissing' ? 37 : _context4.t2 === 'CancelUrlMustBeString' ? 37 : _context4.t2 === 'CancelUrlInvalid' ? 37 : _context4.t2 === 'StripeJsLibraryMissing' ? 37 : _context4.t2 === 'SubscriptionNotPurchased' ? 37 : _context4.t2 === 'StripeAccountNotConnected' ? 37 : _context4.t2 === 'PaymentsDisabled' ? 37 : _context4.t2 === 'UserMustChangePassword' ? 37 : _context4.t2 === 'UserNotSignedIn' ? 37 : _context4.t2 === 'TooManyRequests' ? 37 : _context4.t2 === 'ServiceUnavailable' ? 37 : 38;
            break;

          case 37:
            throw _context4.t1;

          case 38:
            throw new errors.UnknownServiceUnavailable(_context4.t1);

          case 39:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 32], [5, 19]]);
  }));

  return function updatePaymentMethod(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

export default {
  purchaseSubscription: purchaseSubscription,
  cancelSubscription: cancelSubscription,
  resumeSubscription: resumeSubscription,
  updatePaymentMethod: updatePaymentMethod
};